/* eslint-disable func-names, max-len, no-new, no-plusplus, no-underscore-dangle */
/* global ko:false */

import 'fancybox-core';
import 'fancybox-media';

let ko = {};
const mediaCentreHome = document.getElementById('media-centre-home');

if (mediaCentreHome !== null) {
  require.ensure(['knockout'], (require) => {
    ko = require('knockout');
    require('knockout-mapping');
    require('../../bindings/ko-fancybox');
    require('../../bindings/ko-isotope');
    initComponent();
  });
}

function initComponent() {
  const ProCommunity = function () {
    const self = this;

    self.model = {};

    self.settings = {
      pageSize: 3,
    };

    self.initialise = function () {
      const $area = $('.filterArea');
      const $filterBtn = $('.filterBtn');
      const $loader = $('.ajaxLoader').parent();

      $filterBtn.click(() => {
        $area.slideToggle();
      });

      self.container = mediaCentreHome;

      self.model.pageNumber = 1;

      self.model.categories = [];
      self.model.items = ko.observableArray();
      self.model.totalItems = 0;
      self.model.selectedType = ko.observable('');

      function RebindList() {
        $loader.show();
        $loader.css('visibility', 'visible');
        $.ajax({
          type: 'POST',
          url: '/sitefiles/webservices/media.asmx/GetMediaItems',
          data: `{ pageSize: ${self.settings.pageSize}, pageNumber: ${self.model.pageNumber}, selectedType: '${self.model.selectedType()}' }`,
          contentType: 'application/json; charset=utf-8',
          dataType: 'jsonp',
          success(data) {
            let items = self.model.items();
            items = items.concat(data.d.Data.items);
            self.model.items(items);
            $loader.hide();
          },
          error() {},
        });
      }

      self.model.canLoadMore = ko.computed(() => self.model.totalItems > self.model.items().length);

      // load items via ajax, append to items array
      self.model.loadMore = function () {
        self.model.pageNumber += 1;
        RebindList();
      };

      self.model.filter = function (category) {
        self.model.items([]);
        self.model.selectedType(category);
        self.model.pageNumber = 1;
        RebindList();
      };

      // bind items, will currently be empty
      RebindList();
      $loader.show();
      $.ajax({
        type: 'POST',
        url: '/sitefiles/webservices/media.asmx/GetMediaCategories',
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
        success(data) {
          self.model.categories = ko.mapping.fromJS(data.d.Data);
          self.model.categories.unshift('');
          ko.applyBindings(self.model, self.container);
          $loader.hide();
        },
        error() {},
      });
    };
    self.initialise();
  };

  ProCommunity();
}
